import { useEffect, useRef, useState } from 'react';
import { FaEye, FaEyeSlash, FaSync } from 'react-icons/fa';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import 'react-toastify/dist/ReactToastify.css';
import config, { RemoveSession, SetSession } from '../../EnvConfig/env_config';
import BlurLoader from '../CommonComponents/BlurFullPageLoader';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, ApiCallOnLogin } from '../CommonComponents/CustomHooks';
export default function SignIn() {
    const inputrefs = useRef([]);
    const canvasRef = useRef(null);
    const StaticToken = config.secret_key;
    const navigate = useNavigate();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false)
    const [user, setUser] = useState({ userCode: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);
    const [captcha, setCaptcha] = useState('');
    const [inputCaptcha, setInputCaptcha] = useState('');


    const handleLogin = async () => {

        if (!user.userCode) {
            NotificationSound('ERROR', 'Please enter User Code.', 'txtUserCode', inputrefs);
            return;
        }
        if (!user.password) {
            NotificationSound('ERROR', 'Please enter Password.', 'txtPassword', inputrefs);
            return;
        }

        if (!inputCaptcha) {
            NotificationSound('ERROR', 'Please enter captcha.', 'txtCaptcha', inputrefs);
            return;
        }
        if (inputCaptcha !== captcha) {
            NotificationSound('ERROR', 'Invalid Captcha.', 'txtCaptcha', inputrefs);
            getCaptcha();
            return;
        }

        setIsLoading(true);
        const data = {
            ...user,
            AuthToken: StaticToken,
            LoginUserCode: '',
            Source: 'web'
        }
        let res = await ApiCall(`/api/UserLogin/Login`, data)
        if (res.status === 'SUCCESS') {
            SetSession('cookies', 'token', res.token);
            SetSession('localStorage', 'theme', 'light');
            SetSession('cookies', 'loginUserCode', res.loginUserCode);
            SetSession('cookies', 'loginClientCode', res.loginClientCode);
            SetSession('cookies', 'userName', res.userName);
            SetSession('cookies', 'branchCode', res.loginBCode);
            SetSession('cookies', 'user', res)
            setTimeout(() => {
                setIsLoading(false);
                navigate(location.state || '/dashboard')
                localStorage.setItem('ID', "10040")
            }, 700)

        } else {
            setIsLoading(false);
            NotificationSound(res.status, res.message, res.focus, inputrefs)
        }
    };


    const getCaptcha = async () => {
        setIsLoading(true);
        let res = await ApiCallOnLogin('/api/UserLogin/GenerateCaptcha')
        if (res.status === 'SUCCESS') {
            setCaptcha(res.captchaCode)
            setIsLoading(false);
        }
        else {
            setCaptcha('')
            setIsLoading(false)
            NotificationSound(res.status, res.message, res.focus, inputrefs)
        }
    }



    const SendEmail = async () => {
        setIsLoading(true);
        const data = {
            UserCode: user.userCode,
            AuthToken: StaticToken,
            /* Source: 'web'*/
        }
        let res = await ApiCall(`/api/UserLogin/ForgetPassword`, data)
        setIsLoading(false);
        if (res.status === 'SUCCESS') {
            NotificationSound(res.status, res.message, res.focus, inputrefs)
            setIsLoading(false);
        }
        if (res.status === 'ERROR') {
            NotificationSound(res.status, res.message, res.focus, inputrefs)
            setIsLoading(false);
        }
    };


    const handleTogglePassword = () => {
        setShowPassword((prevShowPassword) => !prevShowPassword);
    };

    useEffect(() => {
        if (captcha && canvasRef.current) {
            const canvas = canvasRef.current;
            const ctx = canvas.getContext('2d');
            ctx.clearRect(0, 0, canvas.width, canvas.height);

            // Background
            ctx.fillStyle = '#f4f4f4';
            ctx.fillRect(0, 0, canvas.width, canvas.height);

            // Add noise dots
            for (let i = 0; i < 60; i++) {
                ctx.fillStyle = `rgba(${Math.random() * 255},${Math.random() * 255},${Math.random() * 255},0.6)`;
                ctx.beginPath();
                ctx.arc(Math.random() * canvas.width, Math.random() * canvas.height, Math.random() * 1.5, 0, Math.PI * 2);
                ctx.fill();
            }

            // Add lines
            for (let i = 0; i < 4; i++) {
                ctx.strokeStyle = `rgba(${Math.random() * 255},${Math.random() * 255},${Math.random() * 255},0.6)`;
                ctx.lineWidth = Math.random() * 2;
                ctx.beginPath();
                ctx.moveTo(Math.random() * canvas.width, Math.random() * canvas.height);
                ctx.lineTo(Math.random() * canvas.width, Math.random() * canvas.height);
                ctx.stroke();
            }

            // Draw text
            ctx.font = 'bold 22px "Courier New", Courier, monospace';
            ctx.textBaseline = 'middle';

            const startX = 10;
            const step = (canvas.width - 20) / captcha.length;

            for (let i = 0; i < captcha.length; i++) {
                const char = captcha[i];
                ctx.save();
                ctx.fillStyle = `rgb(${Math.random() * 100},${Math.random() * 100},${Math.random() * 100})`;
                const angle = (Math.random() - 0.5) * 0.4;
                ctx.translate(startX + (i * step) + (step / 2), canvas.height / 2 + (Math.random() * 6 - 3));
                ctx.rotate(angle);
                ctx.fillText(char, -ctx.measureText(char).width / 2, 0);
                ctx.restore();
            }
        }
    }, [captcha]);

    useEffect(() => {
        getCaptcha()
        inputrefs.current['txtUserCode'].focus()
        SetSession('cookies', 'token', 'EXPIRED')
        SetSession('cookies', 'user', { ...user, loginSessionID: 'EXPIRED' })
        RemoveSession('cookies', 'token')
        RemoveSession('cookies', 'loginUserCode')
        RemoveSession('cookies', 'userName')
        RemoveSession('cookies', 'user')
        RemoveSession('cookies', 'branchCode')
    }, [])

    return (
        <>
            <div className="container-fluid bg-login vh-100 d-flex justify-content-center align-items-center" >
                <div className="row" data-aos="zoom-in" data-aos-duration="1000" style={{ opacity: '0.88' }}>
                    <div className="col-sm-3 px-4 py-5 main-login text-black rounded">
                        <div className=''>
                            <img src="./assets/img/mainlogo.png" className='img1' alt="..." style={{ display: "flex" }} />
                        </div>
                        <div className="innerlogindiv ">
                            <h5 className=" text-center fw-bold" style={{ color: "#74531f", }}><span> Welcome To Grand Slam </span>
                                <br /><span className='fw-bold ' style={{ color: "#74531f", marginTop: '4px', display: 'inline-block' }} >Client Portal</span>
                            </h5>

                            <div className="col-lg-3 col-md-4 col-sm-6" style={{ width: '100%' }}>
                                <div className="fields">
                                    <label className="form-label" style={{ color: '#74531f', fontSize: '14px' }}>User Code </label>
                                    <input
                                        id="txtUserCode"
                                        ref={ref => (inputrefs.current['txtUserCode'] = ref)}
                                        type="text"
                                        className="form-control"
                                        autoComplete="off"
                                        name='userCode'
                                        placeholder='User Code '
                                        maxLength='50'
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtPassword'].focus()
                                            };
                                        }}
                                        value={user.userCode}
                                        onChange={(e) => {
                                            setUser({ ...user, userCode: e.target.value })
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-4 col-sm-6" style={{ width: '100%', position: "relative", }}>
                                <div className="fields">
                                    <label className="form-label" style={{ color: '#74531f', fontSize: '14px' }}>Password / Email ID / Mobile No</label>
                                    <input
                                        id="txtPassword"
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['txtCaptcha']?.focus();
                                            };
                                        }}
                                        type={showPassword ? 'text' : 'password'}
                                        ref={ref => (inputrefs.current['txtPassword'] = ref)}
                                        className="form-control"
                                        autoComplete="off"
                                        placeholder='Password'
                                        maxLength='50'
                                        name='Password'
                                        value={user.password}
                                        onChange={(e) => setUser({ ...user, password: e.target.value })}
                                    />
                                </div>
                                <span style={{ position: "absolute", cursor: "pointer", left: "92%", bottom: "7%" }} onClick={handleTogglePassword}>
                                    {showPassword ? <FaEyeSlash style={{ color: "#74531f" }} /> : <FaEye style={{ color: "#74531f" }} />}
                                </span>
                            </div>

                            <div className="col-lg-3 col-md-4 col-sm-6 mt-2" style={{ width: '100%' }}>
                                <div className="fields d-flex align-items-center gap-2">
                                    <input
                                        id="txtCaptcha"
                                        ref={ref => (inputrefs.current['txtCaptcha'] = ref)}
                                        type="text"
                                        className="form-control"
                                        autoComplete="off"
                                        name='captcha'
                                        placeholder='Enter Captcha'
                                        maxLength='6'
                                        onKeyDown={(e) => {
                                            if (e.key === 'Enter') {
                                                inputrefs.current['btnLogin']?.focus();
                                            };
                                        }}
                                        value={inputCaptcha}
                                        onChange={(e) => setInputCaptcha(e.target.value)}
                                        style={{ flex: 1 }}
                                    />
                                    <canvas
                                        ref={canvasRef}
                                        width="120"
                                        height="38"
                                        className="rounded border"
                                        style={{ width: '120px', height: '35px', cursor: 'not-allowed' }}
                                    />
                                    <span style={{ cursor: "pointer", marginLeft: "2px" }} onClick={getCaptcha} title="Refresh Captcha">
                                        <FaSync style={{ color: "#74531f", fontSize: "16px" }} />
                                    </span>
                                </div>
                            </div>

                            <div className="py-2 loading">
                                <button ref={ref => (inputrefs.current['btnLogin'] = ref)} className='btn  w-100 login-btn loginhover' onClick={handleLogin} >Login</button>
                                {isLoading && (<BlurLoader />)}
                            </div>

                            <Link
                                onClick={SendEmail}
                                style={{ fontSize: "14px", color: '#74531f' }}
                                onMouseEnter={(e) => e.target.style.color = '#CC9966'}
                                onMouseLeave={(e) => e.target.style.color = '#D39240'}
                            >
                                forgot password?
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}





